import React, { useState, useEffect } from 'react';
import { Table, Typography, Row, Col, Input, Button } from 'antd';
import { InfoGenService } from '../Services/InfoGenService';
import { SearchOutlined, FileExcelOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import moment from 'moment';
import "../Pages/CSS/DonnesBases.css";

const { Title } = Typography;

const Effectifs = () => {

  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [searchText, setSearchText] = useState('');
  const [totalSocieties, setTotalSocieties] = useState(0);

  const infosgenService = new InfoGenService();




  const fetchTable = async () => {
    try {
      const data = await infosgenService.getLisInfosGen();
      setTableData(data);
      setFilteredData(data);
      setTotalSocieties(data.length); // Calculer et stocker le nombre total de sociétés
    } catch (error) {
      console.error("Erreur lors de la récupération des périodes :", error);
    }
  };

  useEffect(() => {

    fetchTable();
  }, []);



  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    const filtered = tableData.filter(item =>
      Object.keys(item).some(key =>
        String(item[key]).toLowerCase().includes(value)
      )
    );
    setFilteredData(filtered);
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");
    XLSX.writeFile(wb, "Informations.xlsx");
  };

  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  }

  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      align: 'center',
      sorter: (a, b) => (String(a.code) || "").localeCompare(String(b.code) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: 'Intitulé',
      dataIndex: 'intitule',
      key: 'intitule',
      sorter: (a, b) => (String(a.intitule) || "").localeCompare(String(b.intitule) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: 'Date de Création',
      dataIndex: 'datecreation',
      key: 'datecreation',
      align: 'center',
      render: (text) => text ? moment(text).format("DD/MM/YYYY") : " ",
      sorter: (a, b) => {
        const dateA = a.datecreation ? new Date(a.datecreation) : 0;
        const dateB = b.datecreation ? new Date(b.datecreation) : 0;
        return dateA - dateB;
      },
      sortDirections: ["ascend", "descend"],
    },
    {
      title: 'Total Bénéficiaires',
      dataIndex: 'total_benef',
      key: 'total_benef',
      align: 'right',
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "15px", paddingRight: "15px" }}>
          <strong> {formatNumber(text || " ")}</strong>
        </div>
      ),
      sorter: (a, b) => (a.total_benef || 0) - (b.total_benef || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: 'Nbr de Participants',
      dataIndex: 'nb_part',
      key: 'nb_part',
      align: 'right',
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "15px", paddingRight: "15px" }}>
          <strong> {formatNumber(text || " ")}</strong>
        </div>
      ),
      sorter: (a, b) => (a.nb_part || 0) - (b.nb_part || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: 'Nbr Épouses',
      dataIndex: 'nb_epouse',
      key: 'nb_epouse',
      align: 'right',
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "15px", paddingRight: "15px" }}>
          <strong> {formatNumber(text || " ")}</strong>
        </div>
      ),
      sorter: (a, b) => (a.nb_epouse || 0) - (b.nb_epouse || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: 'Nbr Époux',
      dataIndex: 'nb_epoux',
      key: 'nb_epoux',
      align: 'right',
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "15px", paddingRight: "15px" }}>
          <strong> {formatNumber(text || " ")}</strong>
        </div>
      ),
      sorter: (a, b) => (a.nb_epoux || 0) - (b.nb_epoux || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: 'Nbr Enfants',
      dataIndex: 'nb_enf',
      key: 'nb_enf',
      align: 'right',
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "15px", paddingRight: "15px" }}>
          <strong> {formatNumber(text || " ")}</strong>
        </div>
      ),
      sorter: (a, b) => (a.nb_enf || 0) - (b.nb_enf || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: 'Nbr Ascendants',
      dataIndex: 'nb_asc',
      key: 'nb_asc',
      align: 'right',
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "15px", paddingRight: "15px" }}>
          <strong> {formatNumber(text || " ")}</strong>
        </div>
      ),
      sorter: (a, b) => (a.nb_asc || 0) - (b.nb_asc || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: 'Nbr Autres',
      dataIndex: 'nb_autre',
      key: 'nb_autre',
      align: 'right',
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "15px", paddingRight: "15px" }}>
          <strong> {formatNumber(text || " ")}</strong>
        </div>
      ),
      sorter: (a, b) => (a.nb_autre || 0) - (b.nb_autre || 0),
      sortDirections: ["ascend", "descend"],
    },
  ];

  const summary = (pageData) => {
    let totalBenef = 0;
    let totalPart = 0;
    let totalEpouse = 0;
    let totalEpoux = 0;
    let totalEnf = 0;
    let totalAsc = 0;
    let totalAutre = 0;

    tableData.forEach(({ total_benef, nb_part, nb_epouse, nb_epoux, nb_enf, nb_asc, nb_autre }) => {
      totalBenef += total_benef;
      totalPart += nb_part;
      totalEpouse += nb_epouse;
      totalEpoux += nb_epoux;
      totalEnf += nb_enf;
      totalAsc += nb_asc;
      totalAutre += nb_autre;
    });

    return (
      <Table.Summary.Row>
        <Table.Summary.Cell index={0} colSpan={1} align="right">
          <strong>Total :</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={1} align="right">
          <strong></strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={2} align="right">
          <strong></strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3} align="right">
          <strong>{formatNumber(totalBenef)}</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4} align="right">
          <strong>{formatNumber(totalPart)}</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={5} align="right">
          <strong>{formatNumber(totalEpouse)}</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={6} align="right">
          <strong>{formatNumber(totalEpoux)}</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={7} align="right">
          <strong>{formatNumber(totalEnf)}</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={8} align="right">
          <strong>{formatNumber(totalAsc)}</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={9} align="right">
          <strong>{formatNumber(totalAutre)}</strong>
        </Table.Summary.Cell>
      </Table.Summary.Row>
    );
  };

  return (
    <div>

      <Row justify="space-between" style={{ marginBottom: 16 }}>
        <Col span={12} >
          <Button
            icon={<FileExcelOutlined />}
            className='buttonExport'
            onClick={exportToExcel}
          >
            Exporter
          </Button>
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Input
            prefix={<SearchOutlined />}
            placeholder="Rechercher"
            bordered={false}
            style={{ borderBottom: "2px solid #030303", width: "50%", }}
            value={searchText}
            onChange={handleSearch}
          />
        </Col>

      </Row>
      <Table

        scroll={{ x: true }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        pagination={{ pageSize: 5 }}
        bordered
        className="custom-header1-table"
        columns={columns}
        showSorterTooltip={false}
        dataSource={filteredData}
        rowKey="code"
        summary={summary}
        title={() => <strong>Total Adhérents : {totalSocieties}</strong>}


      />

    </div>
  )
}

export default Effectifs